import {
    GET_APPOINTMENT,
    DELETE_APPOINTMENT,
    ADD_APPOINTMENT,
    UPDATE_APPOINTMENT,
    GET_QUESTION_DETAILS
} from './actionTypes';
import axios from "axios";

export const getAppointment = (url) => {
    // console.log("GET URL:-" + url);
    return dispatch =>
        axios.get(url).then((response) => {
            dispatch({
                type: GET_APPOINTMENT,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const deleteAppointment = (url) => {
    // console.log("DELETE URL:-" + url);
    return dispatch =>
        axios.delete(url).then((response) => {
            dispatch({
                type: DELETE_APPOINTMENT,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const addAppointment = (url, dictionary) => {
    // console.log("ADD URL:-" + url);
    return dispatch =>
        axios.post(url, dictionary, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {

            dispatch({
                type: ADD_APPOINTMENT,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const updateAppointment = (url, dictionary) => {
    // console.log("UPDATE URL:-" + url);
    return dispatch =>
        axios.post(url, dictionary, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            dispatch({
                type: UPDATE_APPOINTMENT,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const getQuestionDetails = (url) => {
    // console.log("GET QUESTION URL:-" + url);
    return dispatch =>
        axios.get(url).then((response) => {
            dispatch({
                type: GET_QUESTION_DETAILS,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};